import axios from "axios";

const httpClient = axios.create({
  // baseURL: "http://localhost:3453",
  // baseURL: "https://community-hub.e-deeshatechnologies.com",
  baseURL: "https://api.community-hub.e-deeshatechnologies.com/",
  headers: { "Content-Type": "application/json" },
});

export default httpClient;